import React from "react";
import clsx from "clsx";
import styles from './style.module.css';
import colors from '../colors/colors.module.css';
import IconProvider from "../IconProvider";
import Typography from "../Typography";
import { RadiobuttonProps } from "./Radiobutton.types";
import { checkbox_indeterminate, checkbox_tik, radiobtnFill } from "../../../assets";


const Radiobutton: React.FC<RadiobuttonProps> = ({size , disabled, className ,onClick,state="unchecked" ,style }: RadiobuttonProps) => {

    const ss = state == "indeterminate" ? "checked" : (state == "checked"  ? "unchecked" : "checked");

    return (
        <div className={clsx(styles.Small , styles[state] , className && className , disabled && styles.disabled)} onClick={()=>{onClick(ss)}} style={style ?style :{}}>
            {state == "checked" && <IconProvider Icon={radiobtnFill}  />}
            {state == "indeterminate" && <IconProvider Icon={checkbox_indeterminate} />}

        </div>
    );
};

export default Radiobutton;

